export default __webpack_public_path__ + "static/media/imagePrintContentOne.91fca606.png";